module.exports = __webpack_public_path__ + "img/Weilin Vision Vehicle Workpiece Inspection Software.d783f30f.jpg";